import { breakpoints } from '../../../constants';
import GlideSlider from '../base';

const glideOptions = {
  type: 'slider',
  startAt: 0,
  perView: 3,
  peek: { before: 0, after: 110 },
  bound: true,
  rewind: true,
  gap: 20,
  breakpoints: {
    525: {
      perView: 1,
      peek: { before: 0, after: 50 },
    },
    [breakpoints['break-1']]: {
      perView: 1,
      peek: { before: 0, after: 110 },
    },
    [breakpoints['break-2']]: {
      perView: 2,
    },
  },
};

const selectors = {
  sliderSelector: '[data-lab-group-slider="slider"]',
  slideSelector: '[data-lab-group-slider="slide"]',
  leftArrowSelector: '[data-lab-group-slider="arrow-left"]',
  rightArrowSelector: '[data-lab-group-slider="arrow-right"]',
};

export default class labGroupSlider {
  constructor(el) {
    this.el = el;
    this.sliderEl = this.el.querySelector(selectors.sliderSelector);
    this.leftArrowBtnEl = this.el.querySelector(selectors.leftArrowSelector);
    this.rightArrowBtnEl = this.el.querySelector(selectors.rightArrowSelector);
    this.initSlider();
    this.addSlideChangeListener();
    this.handleArrowButtonVisibility();
  }

  initSlider() {
    this.labGroupSlider = new GlideSlider(
      this.sliderEl,
      glideOptions,
      selectors,
    );

    this.labGroupSliderGlideInstance = this.labGroupSlider.getGlideSlider();
    this.labGroupSliderGlideInstance.mount();
  }

  addSlideChangeListener() {
    this.labGroupSliderGlideInstance.on('run', () => {
      this.handleArrowButtonVisibility();
    });
  }

  handleArrowButtonVisibility() {
    if (this.labGroupSliderGlideInstance.index === 0) {
      this.leftArrowBtnEl.style.display = 'none';
    } else {
      this.leftArrowBtnEl.style.display = 'flex';
    }

    let perView = 1;
    if (window.matchMedia(`(min-width: ${breakpoints['break-2']}px)`).matches) {
      perView = 3;
    } else if (window.matchMedia(`(min-width: ${breakpoints['break-1']}px)`).matches) {
      perView = 2;
    }

    if (this.labGroupSliderGlideInstance.index >= this.labGroupSlider.getNumberOfSlides() - perView) {
      this.rightArrowBtnEl.style.display = 'none';
    } else {
      this.rightArrowBtnEl.style.display = 'flex';
    }
  }
}
